import { render, staticRenderFns } from "./Contacto_Comp.vue?vue&type=template&id=41b815dc&scoped=true&"
import script from "./Contacto_Comp.vue?vue&type=script&lang=js&"
export * from "./Contacto_Comp.vue?vue&type=script&lang=js&"
import style0 from "./Contacto_Comp.vue?vue&type=style&index=0&id=41b815dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b815dc",
  null
  
)

export default component.exports